import $, { css, get } from "jquery";
import noUiSlider from "nouislider";

$(function () {

  if (window.location.pathname.includes('/order-received/')) {
    return;
  }
  const minPriceInputs = $("#min-price, #min-price-mobile");
  const maxPriceInputs = $("#max-price, #max-price-mobile");

  const priceSliders = ["#price-slider", "#price-slider-mobile"]
    .map((selector) => document.querySelector(selector))
    .filter(Boolean);

  let sortChanged = false;

  $(document).on("change", "#sort-select", function () {
    sortChanged = true;
    applyFilters(1);
  });

  function updateURLParams(filters, minPrice, maxPrice, sort, paged = 1) {
    const params = new URLSearchParams(); //   We do not use Window.location.search

    let baseUrl = window.location.pathname
      .replace(/\/page\/\d+\//, "")
      .replace(/\/+$/, "");

    if (paged > 1) {
      baseUrl += `/page/${paged}/`;
    }

    Object.entries(filters).forEach(([taxonomy, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        params.set(taxonomy, values.join(","));
      }
    });

    if (parseInt(minPrice) > 0) {
      params.set("min_price", minPrice);
    }

    if (parseInt(maxPrice) < 30000) {
      params.set("max_price", maxPrice);
    }

    //add sort only if the user really changed and it is not default
    if (sortChanged && sort && sort !== "date_desc") {
      params.set("sort", sort);
    }

    if (!params.toString()) {
      window.location.href = baseUrl; //Full Reset to WordPress Logic
      return;
    }
    const finalUrl = `${baseUrl}${
      params.toString() ? "?" + params.toString() : ""
    }`;

    if (hasActiveFilters()) {
      window.history.pushState({}, "", finalUrl);
    } else {
      window.history.pushState({}, "", baseUrl);
    }
  }

  function getFilters() {
    const filters = {};

    //forcibly shoot duplicates checkbox: we only leave the first visible
    $(".filter-attribute").each(function () {
      const $this = $(this);
      const name = $this.attr("name");
      const value = $this.val();

      const duplicates = $(
        `.filter-attribute[name="${name}"][value="${value}"]`
      );
      if (duplicates.length > 1) {
        let hasVisible = false;

        duplicates.each(function () {
          const $el = $(this);
          if (!hasVisible && $el.is(":visible")) {
            hasVisible = true; //leave the first visible
          } else {
            $el.prop("checked", false); //Other turn off
          }
        });
      }
    });

    //Now we really read the filters
    $(".filter-attribute").each(function () {
      const $this = $(this);
      const taxonomy = $this.attr("name");
      const value = $this.val();

      if (!filters[taxonomy]) {
        filters[taxonomy] = new Set();
      }

      if ($this.is(":checked")) {
        filters[taxonomy].add(value); //Uniqueness
      }
    });

   //Turn Set → Array and filter empty
    Object.keys(filters).forEach((key) => {
      filters[key] = Array.from(filters[key]).filter(Boolean);
    });

    return filters;
  }

  function getCurrentCategory() {
    let currentCategory = $(".products-loop").data("current-cat");
    if (!currentCategory) {
      let pathArray = window.location.pathname.split("/");
      let categoryIndex = pathArray.indexOf("product-category");
      if (categoryIndex !== -1 && pathArray.length > categoryIndex + 1) {
        currentCategory = pathArray[categoryIndex + 1];
      }
    }
    return currentCategory || null;
  }
  let allowAjax = true;
  function applyFilters(paged = 1, currentUrl = null) {
    if (!allowAjax) return; //Hard lock

    const filters = getFilters();
    const minPrice = $("#min-price").val();
    const maxPrice = $("#max-price").val();
    const sort = $("#sort-select").val() || "date_desc";

    if (!currentUrl) {
      currentUrl = window.location.pathname
        .replace(/\/page\/\d+\//, "")
        .replace(/\/+$/, "");
    }

    const currentCategory = getCurrentCategory();
    $.ajax({
      url: ajax_object.ajaxurl,
      type: "POST",
      data: {
        action: "filter_products",
        filters: filters,
        min_price: minPrice,
        max_price: maxPrice,
        sort: sort,
        category: currentCategory,
        paged: paged,
        current_url: currentUrl,
      },
      beforeSend: function () {
        $("#ajax-filter-spinner").show();
        // $(".products-loop").html("<p>Завантаження...</p>");
        // $(".products-loop").html('<div class="loading-text">Завантаження<span class="dotting">...</span></div>');
        $(".products-loop").html(
          '<div class="loading-text loader">Завантаження<span class="dots"></span></div>'
        );
        $(".pagination-wrapper").empty();
      },
      success: function (response) {
        $("#ajax-filter-spinner").hide();
        $(".products-loop").html(response.products_html);
        $(".pagination-wrapper").html(response.pagination_html);
        if (response.is_empty) {
          $(".products-loop").addClass("is-empty");
          $("#filters-wrapper").hide();
        } else {
          $(".products-loop").removeClass("is-empty");
          $("#filters-wrapper").show();
        }
          
        if (response.available_filters) {
          $(".filter-attribute").each(function () {
            const $checkbox = $(this);
            const taxonomy = $checkbox.attr("name");
            const value = $checkbox.val();
            const isChecked = $checkbox.is(":checked");
            const available = response.available_filters[taxonomy] || [];
        
            const isBrand = taxonomy === "product_brand";
            const isGender = taxonomy === "gender";
        
            if (isBrand) {
              const selectedSizes = $(".filter-attribute[name='pa_rozmir-eu']:checked")
                .map(function () {
                  return $(this).val();
                })
                .get();
            
              const hasSelectedSizes = selectedSizes.length > 0;
            
             //brands that are really available for combination
              const brandAvailable = available.includes(value);
              const isChecked = $checkbox.is(":checked");
            
              if (hasSelectedSizes) {
               //show only those brands that have current sizes or already selected
                if (brandAvailable || isChecked) {
                  $checkbox.closest("li").show();
                  $checkbox.prop("disabled", false);
                } else {
                  $checkbox.closest("li").hide();
                  $checkbox.prop("disabled", true);
                }
              } else {
                //If the size is not selected -show all the brands
                $checkbox.closest("li").show();
                $checkbox.prop("disabled", false);
              }
            }
             else if (isGender) {
              if (available.includes(value) || isChecked) {
                $checkbox.closest("li").show();
                $checkbox.prop("disabled", false);
              } else {
                $checkbox.closest("li").hide();
                $checkbox.prop("disabled", true);
              }
            } else {
              if (available.includes(value) || isChecked) {
                $checkbox.closest("li").show();
                $checkbox.prop("disabled", false);
              } else {
                $checkbox.closest("li").hide();
                $checkbox.prop("disabled", true);
              }
            }
          });
        }
        
        

        updateURLParams(filters, minPrice, maxPrice, sort, paged);
      },
      error: function (xhr) {
        console.log(xhr.responseText);
        $("#ajax-filter-spinner").hide();
        $(".products-loop").html("<p>Сталася помилка. Спробуйте ще раз.</p>");
        $(".pagination-wrapper").empty();
      },
    });
  }

  function getCleanPath() {
    return window.location.pathname
      .replace(/\/page\/\d+\/?$/, "")
      .replace(/\/+$/, "");
  }

  function hasActiveFilters() {
    const sortValue = $("#sort-select").val();

    return (
      $(".filter-attribute:checked").length > 0 ||
      $("#min-price").val() > 0 ||
      $("#max-price").val() < 30000 ||
      (sortValue && sortValue !== "date_desc")
    );
  }

  $(document).on("click", ".pagination-wrapper a", function (e) {
    e.preventDefault();

    const $this = $(this);
    const href = $this.attr("href");

    if (!href || $this.hasClass("current")) return;

    const url = new URL(href, window.location.origin);
    const pathParts = url.pathname.split("/");
    const pageIndex = pathParts.indexOf("page");
    const paged = pageIndex !== -1 ? parseInt(pathParts[pageIndex + 1]) : 1;
    let cleanPath = window.location.pathname
      .replace(/\/page\/\d+\//, "")
      .replace(/\/+$/, "");
    applyFilters(paged, getCleanPath());
  });

  priceSliders.forEach((slider) => {
    noUiSlider.create(slider, {
      start: [
        parseInt($("#min-price").val()) || 0,
        parseInt($("#max-price").val()) || 30000,
      ],
      connect: true,
      step: 100,
      range: { min: 0, max: 30000 },
    });

    slider.noUiSlider.on("update", (values) => {
      minPriceInputs.val(Math.round(values[0]));
      maxPriceInputs.val(Math.round(values[1]));
    });

    slider.noUiSlider.on("change", applyFilters);
  });

  minPriceInputs.on("change", function () {
    priceSliders.forEach((slider) => {
      slider.noUiSlider.set([$(this).val(), null]);
    });
    applyFilters();
  });

  maxPriceInputs.on("change", function () {
    priceSliders.forEach((slider) => {
      slider.noUiSlider.set([null, $(this).val()]);
    });
    applyFilters();
  });

  $(document).on("change", ".filter-attribute, #sort-select", function () {
    const sort = $("#sort-select").val() || "date_desc";
    const minPrice = $("#min-price").val();
    const maxPrice = $("#max-price").val();

    const noFilters =
      !hasActiveFilters() &&
      sort === "date_desc" &&
      (!minPrice || parseInt(minPrice) === 0) &&
      (!maxPrice || parseInt(maxPrice) === 30000);

    if (noFilters) {
      allowAjax = false; // 💣 стоп!
      location.replace(getCleanPath());
      return;
    }

    allowAjax = true;
    applyFilters(1);
  });

  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.toString()) {
    urlParams.forEach((value, key) => {
      if (key === "sort") {
        $("#sort-select").val(value);
      } else if (key === "min_price") {
        $("#min-price, #min-price-mobile").val(value);
      } else if (key === "max_price") {
        $("#max-price, #max-price-mobile").val(value);
      } else {
        $(`.filter-attribute[name="${key}"]`).prop("checked", false);

        value.split(",").forEach((term) => {
          $(`.filter-attribute[name="${key}"][value="${term}"]`).prop(
            "checked",
            true
          );
        });
      }
    });

    // restore the price of the price slider -to ApplyFilters
    priceSliders.forEach((slider) => {
      if (slider && slider.noUiSlider) {
        slider.noUiSlider.set([
          $("#min-price").val() || 0,
          $("#max-price").val() || 30000,
        ]);
      }
    });

    // now launch filtration -only after all recovery
    allowAjax = true;
    applyFilters(getCurrentPage());

    // Trigger only if there are active filters
    // if (
    //   $(".filter-attribute:checked").length > 0 ||
    //   parseInt($("#min-price").val()) > 0 ||
    //   parseInt($("#max-price").val()) < 30000 ||
    //   $("#sort-select").val() !== "date_desc"
    // ) {
    //   applyFilters(getCurrentPage());
    // }
  }

  function getCurrentPage() {
    const pathParts = window.location.pathname.split("/");
    const pageIndex = pathParts.indexOf("page");
    // console.log("pageIndex", pageIndex);

    return pageIndex !== -1 ? parseInt(pathParts[pageIndex + 1]) : 1;
  }
});
